import React, {Component} from 'react';
import "../CSS/appointment.css"
import ProgressBarElement from "../Components/ProgressBarElement.js"
import Location from "../Components/Location.js"
import Service from "../Components/Service.js"
import ErrorMessage from "../Components/ErrorMessage.js"
import Vehicle from "../Components/Vehicle.js"
import DateTime from "../Components/DateTime.js"
import Summary from "../Components/Summary.js"
import AppointmentService from '../utils/AppointmentService.js';
import ErrorSnackBar from '../Components/ErrorSnackBar.js';
import moment from 'moment'
import '../CSS/Template.css'


import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export default class NewAppointment extends Component {
  constructor(props){

    super(props);
    this.state = {
      show: false,
      createNewVehicle: false,
      addresses: [],
      appointmentAddress: null,
      appointmentDateTime: null,
      appointmentVehicle: null,
      appointmentVehicles: [],
      appointmentVehiclesIds: [],
      appointmentService: null,
      appointmentServices: [],
      appointmentUpgrades: null,
      appointmentItems: [],
      allUpgradesMap: [],
      allUpgradesArray: [],
      upgradesMap: [],
      currentLocation: null,
      vehicles: [],
      showLocation: true,
      showVehicle: false,
      showServices: false,
      showDateTime: false,
      showSummary: false,
      promoSnackMessage: '',
      openPromoSnack: false,
      earlyPromoCode: null,
      promoAmount: 0,
      errorMessage:null,
      color: '#c42d2d',
      open: false,
      user: null,
    }
    this.setVariables = this.setVariables.bind(this)
    this.setLocalStorage = this.setLocalStorage.bind(this)
    this.setError = this.setError.bind(this)
    this.showLocation = this.showLocation.bind(this)
    this.showVehicle = this.showVehicle.bind(this)
    this.selectVehicle = this.selectVehicle.bind(this)
    this.selectService= this.selectService.bind(this)
    this.selectDateTime= this.selectDateTime.bind(this)
    this.selectUpgrades = this.selectUpgrades.bind(this)
    this.addEarlyPromoCode = this.addEarlyPromoCode.bind(this)
    this.showDatetimeOnClick = this.showDatetimeOnClick.bind(this)
    this.addVehicle = this.addVehicle.bind(this)
    //this.addUpgradesToArray = this.addUpgradesToArray.bind(this)
    this.savePromoAmount = this.savePromoAmount.bind(this)
    this.ApptService = new AppointmentService()
    this.ApptService.addresses()
    .then(res =>{
      const addresses = res
      this.setState({ addresses: addresses});
      this.forceUpdate()
      //  this.props.history.replace('/');
    })
    .catch(err =>{
        throw new Error('Error fetching addresses on NewAppointment.js: ' + err.message);
    })
    this.ApptService.vehicles()
    .then(res =>{
      const vehicles = res
      this.setState({vehicles: vehicles});
      this.forceUpdate()
      //  this.props.history.replace('/');
    })
    .catch(err =>{
        throw new Error('Error fetching vehicles on NewAppointment.js: ' + err.message);
    })
  }
  componentWillMount(){
    var lat = localStorage.getItem('lat')
    var lng = localStorage.getItem('lng')
    if(localStorage.getItem('appointmentAddress') && localStorage.getItem('appointmentVehicle') && localStorage.getItem('apptDateTime') && localStorage.getItem('appointmentPackage') ){
      this.setVariables()
    }
    this.ApptService.getUser()
    .then(res =>{
      if(res){
        this.setState({
          user: res
        })
      }
      else{
      }
    })
  }
  showLocation(){
    var otherProgressBars = document.getElementsByClassName('progressBarElement')
    for (var i = 0; i < otherProgressBars.length; i++){
      if(otherProgressBars[i].style) {
        otherProgressBars[i].style.backgroundColor = "#E5E6E8";
      }
    }
    var vehicleProgressBar = document.getElementById('step1')
    if(vehicleProgressBar.style){
      vehicleProgressBar.style.backgroundColor = "#5BBA76";
    }
    this.setState({
      showVehicle: false,
      showLocation: true,
      showServices: false,
      showDateTime: false,
      showSummary: false,
    });
  }
  setLocalStorage(id, value){
    localStorage.setItem(id, value)
  }
  showVehicle(addressId) {
    if(addressId){
      this.setState({
        appointmentAddress: addressId,
        open:false
      });
      var appointmentVehicle = this.state.appointmentVehicle
      if(appointmentVehicle){
        var selectedVehicle = ("vehicle" + appointmentVehicle.id)


        if(selectedVehicle){
          //this.refs.selectedVehicle.style.backgroundColor = 'red'
        }
      }
    }
    if(addressId || this.state.appointmentAddress){
      var otherProgressBars = document.getElementsByClassName('progressBarElement')
      for (var i = 0; i < otherProgressBars.length; i++){
        if(otherProgressBars[i].style) {
          otherProgressBars[i].style.backgroundColor = "#E5E6E8";
          otherProgressBars[i].style.color = "black";
        }
      }
      var vehicleProgressBar = document.getElementById('step2')
      if(vehicleProgressBar.style){
        vehicleProgressBar.style.backgroundColor = "#5BBA76";
        vehicleProgressBar.style.color = "white";
      }
      this.setState({
        showVehicle: true,
        showLocation: false,
        showServices: false,
        showDateTime: false,
        showSummary: false,
        errorMessage: false
      });
    }
    else if(!this.state.appointmentAddress && !addressId){
      this.setState({
        open:true,
        errorMessage: "Please select a Location"
      })
    }

  }
  selectVehicle(vehicle) {
      if(vehicle){
        this.setState({
          appointmentVehicle: vehicle,
          open:false
        })
      }
      if((!this.state.appointmentVehicle && !vehicle) || !this.state.appointmentAddress){
        this.setState({
          open:true,
          errorMessage: "Please select a Location and Vehicle"
        })
      }
      else {
        var otherProgressBars = document.getElementsByClassName('progressBarElement')
        for (var i = 0; i < otherProgressBars.length; i++){
          if(otherProgressBars[i].style) {
            otherProgressBars[i].style.backgroundColor = "#E5E6E8";
            otherProgressBars[i].style.color = "black";
          }
        }
        var vehicleProgressBar = document.getElementById('step3')
        vehicleProgressBar.style.backgroundColor = "#5BBA76";
        vehicleProgressBar.style.color = "white";
        this.setState({
          showVehicle: false,
          showLocation: false,
          showServices: true,
          showDateTime: false,
          showSummary: false
        });
    }
  }
  savePromoAmount(promoAmount) {
    if(promoAmount > 0){
      this.setState({
        promoAmount: promoAmount
      })
    }
  }

  selectDateTime(dateTime){
    if(dateTime){
      this.setState({
        appointmentDateTime: dateTime,
        open:false
      })
    }
    if(!this.state.appointmentVehicle && !dateTime && !this.state.appointmentAddress){
      this.setState({
        open:true,
        errorMessage: "Please select a Vehicle, Location and Service"
      })
    }
    else {
      var otherProgressBars = document.getElementsByClassName('progressBarElement')
      for (var i = 0; i < otherProgressBars.length; i++){
        if(otherProgressBars[i].style) {
          otherProgressBars[i].style.backgroundColor = "#E5E6E8";
          otherProgressBars[i].style.color = "black";
        }
      }
      var vehicleProgressBar = document.getElementById('step5')
      vehicleProgressBar.style.backgroundColor = "#5BBA76";
      vehicleProgressBar.style.color = "white";
      this.setState({
        showVehicle: false,
        showLocation: false,
        showServices: false,
        showDateTime: false,
        showSummary: true
      });
      this.setLocalStorage('appointmentAddress', JSON.stringify(this.state.appointmentAddress))
      this.setLocalStorage('appointmentVehicles', JSON.stringify(this.state.appointmentVehicles))
      this.setLocalStorage('appointmentVehicle', JSON.stringify(this.state.appointmentVehicle))
      this.setLocalStorage('appointmentServices', JSON.stringify(this.state.appointmentServices))
      this.setLocalStorage('allUpgradesArray', JSON.stringify(this.state.allUpgradesArray))
      this.setLocalStorage('allUpgradesMap', JSON.stringify(this.state.allUpgradesMap))
      this.setLocalStorage('upgradesMap', JSON.stringify(this.state.upgradesMap))
      this.setLocalStorage('appointmentUpgrades', JSON.stringify(this.state.appointmentUpgrades))
      this.setLocalStorage('promoAmount', JSON.stringify(this.state.promoAmount))
      this.setLocalStorage('user', JSON.stringify(this.state.user))
      this.setLocalStorage('addVehicle', JSON.stringify(this.state.addVehicle))
      this.setLocalStorage('apptDateTime', JSON.stringify(dateTime))
      this.setLocalStorage('appointmentPackage', JSON.stringify(this.state.appointmentService))
      this.setLocalStorage('appointmentItems', JSON.stringify(this.state.appointmentItems))
    }
  }
  setVariables() {
    this.setState({
      appointmentAddress: JSON.parse(localStorage.getItem('appointmentAddress')),
      appointmentVehicles: JSON.parse(localStorage.getItem('appointmentVehicles')),
      appointmentServices: JSON.parse(localStorage.getItem('appointmentServices')),
      appointmentVehicle: JSON.parse(localStorage.getItem('appointmentVehicle')),
      appointmentUpgrades: JSON.parse(localStorage.getItem('appointmentUpgrades')),
      allUpgradesArray: JSON.parse(localStorage.getItem('allUpgradesArray')),
      allUpgradesMap: JSON.parse(localStorage.getItem('allUpgradesMap')),
      upgradesMap: JSON.parse(localStorage.getItem('upgradesMap')),
      promoAmount: JSON.parse(localStorage.getItem('promoAmount')),
      appointmentItems: JSON.parse(localStorage.getItem('appointmentItems')),
      user: JSON.parse(localStorage.getItem('user')),
      // addVehicle: JSON.parse(localStorage.getItem('addVehicle')),
      appointmentDateTime: moment(JSON.parse(localStorage.getItem('apptDateTime'))),
      appointmentService: JSON.parse(localStorage.getItem('appointmentPackage')),
      showVehicle: false,
      showLocation: false,
      showServices: false,
      showDateTime: false,
      showSummary: true
    },() =>{
      var otherProgressBars = document.getElementsByClassName('progressBarElement')
      for (var i = 0; i < otherProgressBars.length; i++){
        if(otherProgressBars[i].style) {
          otherProgressBars[i].style.backgroundColor = "#E5E6E8";
          otherProgressBars[i].style.color = "black";
        }
      }
      var vehicleProgressBar = document.getElementById('step5')
      if(vehicleProgressBar.style){
        vehicleProgressBar.style.backgroundColor = "#5BBA76";
        vehicleProgressBar.style.color = "white";
      }
    })
  }
  selectService(service) {
    if(service){
      this.setState({
        appointmentService: service
      })
    }
  }

  selectUpgrades(upgrades, upgradesMap, service) {
    if(service){
      this.setState({
        upgradesMap: upgradesMap,
        appointmentUpgrades: Array.from(upgrades),
      }, function () {
          this.addAppointmentDetailsToArray(Array.from(upgrades), upgradesMap)
            var otherProgressBars = document.getElementsByClassName('progressBarElement')
            if(this.state.appointmentDateTime){
              for (var i = 0; i < otherProgressBars.length; i++){
                if(otherProgressBars[i].style) {
                  otherProgressBars[i].style.backgroundColor = "#E5E6E8";
                  otherProgressBars[i].style.color = "black";
                }
              }
              var vehicleProgressBar = document.getElementById('step5')
              if(vehicleProgressBar.style){
                vehicleProgressBar.style.backgroundColor = "#5BBA76";
                vehicleProgressBar.style.color = "white";
              }
              this.setState({
                showVehicle: false,
                showLocation: false,
                showServices: false,
                showDateTime: false,
                showSummary: true
              });
            }
            else{
              for (var i = 0; i < otherProgressBars.length; i++){
                if(otherProgressBars[i].style) {
                  otherProgressBars[i].style.backgroundColor = "#E5E6E8";
                  otherProgressBars[i].style.color = "black";
                }
              }
              var vehicleProgressBar = document.getElementById('step4')
              if(vehicleProgressBar.style){
                vehicleProgressBar.style.backgroundColor = "#5BBA76";
                vehicleProgressBar.style.color = "white";
              }
              this.setState({
                showVehicle: false,
                showLocation: false,
                showServices: false,
                showDateTime: true,
                showSummary: false
              });
            }
    });
    }
    if(!this.state.appointmentVehicle && !service && !this.state.appointmentAddress){
      this.setState({
        open:true,
        errorMessage: "Please select a Vehicle, Location and Service"
      })
    }
  }
  showDatetimeOnClick() {
    if(!this.state.appointmentVehicle || !this.state.appointmentAddress || !this.state.appointmentService ){
      this.setState({
        open:true,
        errorMessage: "Please select a Vehicle, Location and Service",
        showVehicle: false,
        showLocation: false,
        showServices: true,
        showDateTime: false,
        showSummary: false
      })
    }
    else{
      var otherProgressBars = document.getElementsByClassName('progressBarElement')
      for (var i = 0; i < otherProgressBars.length; i++){
        if(otherProgressBars[i].style) {
          otherProgressBars[i].style.backgroundColor = "#E5E6E8";
          otherProgressBars[i].style.color = "black";
        }
      }
      var vehicleProgressBar = document.getElementById('step4')
      if(vehicleProgressBar.style){
        vehicleProgressBar.style.backgroundColor = "#5BBA76";
        vehicleProgressBar.style.color = "white";
      }
      this.setState({
        showVehicle: false,
        showLocation: false,
        showServices: false,
        showDateTime: true,
        showSummary: false,
        open:false
      });
    }
  }

  addAppointmentDetailsToArray(selectedUpgradeIds, upgradeOptions) {
    var appointmentItems = [...this.state.appointmentItems];
    var appointmentIndex = appointmentItems.findIndex((element) => element.vehicleId === this.state.appointmentVehicle.id);
    var upgrades = upgradeOptions && selectedUpgradeIds ? upgradeOptions.filter(upgrade => selectedUpgradeIds.includes(upgrade.id)) : [];
    var apptDetails = {
      vehicleId: this.state.appointmentVehicle.id,
      serviceId: this.state.appointmentService.id,
      upgradeIds: this.state.appointmentUpgrades,
      vehicle: this.state.appointmentVehicle,
      service: this.state.appointmentService,
      upgrades: upgrades
    };

    if(appointmentIndex >= 0){
      appointmentItems[appointmentIndex] = apptDetails;
    }
    else{
      appointmentItems.push(apptDetails)
    }

    this.setState({appointmentItems
    }, function () {
      this.setLocalStorage('appointmentItems', JSON.stringify(this.state.appointmentItems))
    });
  }

  selectLocation(address){
    this.setState({
      appointmentAddress: address
    })
    this.showVehicle()
  }
  addVehicle() {
    this.setState({
      createNewVehicle: true,
      showVehicle: true,
      showLocation: false,
      showServices: false,
      showDateTime: false,
      showSummary: false,
      appointmentVehicle: null,
      appointmentService: null,
      appointmentUpgrades: null
    });
  }

  addEarlyPromoCode(earlyCode) {
    this.setState({
      openPromoSnack: false,
    });
    this.setState({
      earlyPromoCode: earlyCode,
      promoSnackMessage: `We\'ll try to apply code \'${earlyCode}\' at checkout.`,
      openPromoSnack: true,
    });
  }

  onInfoSnackClose = () => {
    this.setState({
      openPromoSnack: false,
    });
  }

  clearEarlyPromo = () => {
    this.setState({
      earlyPromoCode: null,
    });
  }

  setOpenToFalse = () => {
    this.setState({
      open:false
    })
  }
  setError(errorMessage){
    this.setState({
      errorMessage: errorMessage,
      open: true,
      color: '#A63D40',
    })
  }
  render() {
    var triangle0Back = '#E5E6E8', triangle1Back = '#E5E6E8', triangle2Back = '#E5E6E8', triangle3Back = '#E5E6E8', triangle4Back= '#E5E6E8', triangle4Border = '#E5E6E8', triangle0Border= '#E5E6E8', triangle1Border= '#E5E6E8', triangle2Border = '#E5E6E8', triangle3Border = '#E5E6E8'
    if(this.state.showLocation){
      triangle0Back = '#5BBA76'
      triangle1Border = '#5BBA76'
    }
    else if(this.state.showVehicle){
      triangle1Back = '#5BBA76'
      triangle2Border = '#5BBA76'
    }
    else if(this.state.showServices){
      triangle2Back = '#5BBA76'
      triangle3Border = '#5BBA76'
    }
    else if(this.state.showDateTime){
      triangle3Back = '#5BBA76'
      triangle4Border = '#5BBA76'
    }
    return (
      <div>
        <div className = "progressBar">
        <Route exact path ="/new-appointment/location" component={Location}/>
          <div className="arrow-right" style={{backgroundColor: triangle0Back, 'borderLeftColor': triangle0Border}}></div>
          <ProgressBarElement showLocation = {this.showLocation} showService = {this.selectVehicle} showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} color={'#5BBA76'} textColor='white' stepNumber = "1" step="Location"/>
          <div className="arrow-right" style={{backgroundColor: triangle1Back, 'borderLeftColor': triangle1Border}}></div>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "2" step="Vehicle"/>
          <div className="arrow-right" style={{backgroundColor: triangle2Back, 'borderLeftColor': triangle2Border}}></div>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "3" step="Service"/>
          <div className="arrow-right" style={{backgroundColor: triangle3Back, 'borderLeftColor': triangle3Border}}></div>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "4" step="Date"/>
          <div className="arrow-right" style={{backgroundColor: triangle4Back, 'borderLeftColor': triangle4Border}}></div>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "5" step="Summary"/>
        </div>
        <div className="maxWidth">
          {(this.state.errorMessage && this.state.errorMessage.length) &&
            <ErrorSnackBar setOpenToFalse = {this.setOpenToFalse} color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
          }
          <div className = 'wrapper'>
          {this.state.showLocation &&
            <Location showOnlyWork = {false} selectedLocation = {this.state.appointmentAddress} addresses={this.state.addresses} currentLocation={this.state.currentLocation} selectLocation={this.showVehicle} setError={this.setError} />
          }
          {this.state.showVehicle &&
              <Vehicle ref={this.vehicle} vehicles={this.state.vehicles} selectVehicle={this.selectVehicle} selectedVehicle = {this.state.appointmentVehicle} allVehicles={this.state.appointmentVehiclesIds} setError={this.setError}/>}
         {this.state.showServices &&
                <Service addEarlyPromoCode={this.addEarlyPromoCode} savePromoAmount = {this.savePromoAmount} selectedVehicle = {this.state.appointmentVehicle} selectedPackage={this.state.appointmentService} selectUpgrades={this.selectUpgrades} selectService = {this.selectService} address_id={this.state.appointmentAddress.id} vehicle_id={this.state.appointmentVehicle.id} zipcode={this.state.appointmentAddress.postal} setError={this.setError} />
         }

            {this.state.showServices &&<ErrorSnackBar onSnackClosed={this.onInfoSnackClose} color = {'green'} open={this.state.openPromoSnack} message = {this.state.promoSnackMessage}/>}
        {(this.state.showDateTime && this.state.appointmentService) &&
                <DateTime workMinutes={this.state.appointmentService.work_minutes} selectDateTime={this.selectDateTime}  cbuOpenTime = {this.state.appointmentAddress.cbu.open_time} cbuCloseTime = {this.state.appointmentAddress.cbu.close_time} blackoutDays = {this.state.appointmentAddress.blackout_dates} cbuClosedDates = {this.state.appointmentAddress.cbu_closed_dates} selectedDateTime = {this.state.appointmentDateTime}/>}
        {this.state.showSummary &&
                  <Summary clearEarlyPromo={this.clearEarlyPromo} earlyPromoString={this.state.earlyPromoCode} appointmentItems={this.state.appointmentItems} setVariables = {this.setVariables} user={this.state.user} allUpgradesArray={this.state.allUpgradesArray}  allUpgradesMap={this.state.upgradesMap} appointmentVehicles = {this.state.appointmentVehicles} appointmentServices = {this.state.appointmentServices} addVehicle = {this.addVehicle} apptDateTime = {this.state.appointmentDateTime} appointmentAddress = {this.state.appointmentAddress} appointmentVehicle = {this.state.appointmentVehicle} appointmentAddress = {this.state.appointmentAddress} appointmentPackages = {this.state.appointmentItems.map(item => item.service)} appointmentPackage = {this.state.appointmentService} upgradesMap = {this.state.upgradesMap} appointmentUpgrades = {this.state.appointmentUpgrades} appointmentSelectedUpgrades = {this.state.appointmentItems.map(item => item.upgrades)} setError = {this.setError}/>}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/NewAppointment.js